module.exports = __webpack_public_path__ + "img/order_query.6b0b07b4.png";